// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_avatar__6j7G8","phAnimation":"avatar_phAnimation__sxSVG"};